/**
 * Painel de demonstração — só em desenvolvimento e staging.
 *
 * Espelha o painel lateral do protótipo aprovado, com uma diferença que
 * importa: ele controla **apresentação**, não dados. Move o "hoje" sobre as
 * datas da viagem aberta e força estados de tela; não troca a viagem, não
 * troca papel e não inventa conteúdo.
 *
 * O seletor de papel saiu. Papel é do servidor: fingir "sou participante" na
 * interface só escondia botões, enquanto a autorização de verdade continuava
 * sendo a real — o painel mostrava uma tela que ninguém teria.
 */
import type { TripPhase } from '@nv/core';

import { useDemo } from '../../demo/DemoContext';
import type { DataState } from './model';

const FASES: Array<{ value: TripPhase | null; label: string }> = [
  { value: null, label: 'Real' },
  { value: 'antes', label: 'Antes' },
  { value: 'durante', label: 'Durante' },
  { value: 'depois', label: 'Depois' },
];

const ESTADOS: DataState[] = ['ready', 'loading', 'empty', 'error'];

export function DemoPanel() {
  const props = useDemo();
  return (
    <aside className="demo-panel" aria-label="Painel de demonstração">
      <div className="demo-panel__row">
        <span className="demo-panel__legend">Fase</span>
        {FASES.map((f) => (
          <button
            key={f.label}
            type="button"
            className={props.phase === f.value ? 'demo-chip demo-chip--on' : 'demo-chip'}
            onClick={() => props.setPhase(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="demo-panel__row">
        <span className="demo-panel__legend">Dados</span>
        {ESTADOS.map((estado) => (
          <button
            key={estado}
            type="button"
            className={props.dataState === estado ? 'demo-chip demo-chip--on' : 'demo-chip'}
            onClick={() => props.setDataState(estado)}
          >
            {estado}
          </button>
        ))}
        <button
          type="button"
          className={props.offline ? 'demo-chip demo-chip--on' : 'demo-chip'}
          onClick={() => props.setOffline(!props.offline)}
        >
          offline
        </button>
      </div>
    </aside>
  );
}
